/*eslint-disable*/
import React, {Component} from "react";
import {Link, withRouter} from 'react-router-dom';
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import {List, ListItem, withStyles} from "@material-ui/core";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

// function Footer({ ...props }) {
class Footer extends Component {
  renderLinks () {
    const {classes} = this.props;

    const leftLinks = (
      <div className={classes.left}>
        <List className={classes.list}>
          <ListItem className={classes.inlineBlock}>
            <Link className={classes.block} to={'/privacy-policy'}>Privacy</Link>
          </ListItem>
          <ListItem className={classes.inlineBlock}>
            <Link className={classes.block} to={'/terms-and-conditions'}>Terms & Conditions</Link>
          </ListItem>
          <ListItem className={classes.inlineBlock}>
            <Link className={classes.block} to={'/patents'}>Patents</Link>
          </ListItem>
          {/* TODO FIXME <ListItem className={classes.inlineBlock}>
            <Link className={classes.block} to='/sitemap.xml'>Site Map</Link>
          </ListItem> */}
        </List>
      </div>
    );

    return leftLinks;
  }

  render () {
    const {classes, whiteFont} = this.props;
    const footerClasses = classNames({
      [classes.footer]: true,
      [classes.footerWhiteFont]: whiteFont
    });
    const aClasses = classNames({
      [classes.a]: true,
      [classes.footerWhiteFont]: whiteFont
    });

    return (
      <footer className={footerClasses}>
        <div className={classes.container}>
          {this.renderLinks()}
          <div className={classes.right}>
            &copy; {1900 + new Date().getYear()} , made with{" "}
            <Favorite className={classes.icon} /> by{" "}
            <Link className={aClasses} to="/">Trinity Info Media, LLC</Link>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withRouter((withStyles(footerStyle)(Footer)));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx